<template>
  <div>
    <div
        class="d-flex justify-content-end"
        style="top: -48px; position: relative"
    >
      <button
          class="btn"
          type="button"
          style="
          background-color: #ff375e;
          border-radius: 50%;
          height: 48px;
          width: 48px;
        "
          data-toggle="modal"
          data-target="#activityFeedModal"
          title="Create post"
      >
        <i class="fa fa-comment-alt text-white" ></i>
      </button>
    </div>

    <div style="margin-top: -48px">
      <div class="col-12" style="padding: 0; margin: 0 -6px">
        <ul v-if="tasksEnabled" class="nav nav-pills nav-fill" role="tablist">
          <li
              class="nav-item nav-border-override"
              role="presentation"
              style="margin-left: -15px"
          >
            <a
                class="nav-link"
                :class="{ active: currentTab === 1 }"
                id="feed_news-tab"
                data-toggle="pill"
                href="#feed_news"
                role="tab"
                aria-controls="feed_news"
                aria-selected="true"
                @click="currentTab = 1"
            >
              News
            </a>
          </li>
          <li
              class="nav-item nav-border-override"
              role="presentation"
              style="margin-right: -27px"
          >
            <a
                class="nav-link"
                :class="{ active: currentTab === 2 }"
                id="chart-tab"
                data-toggle="pill"
                href="#chart"
                role="tab"
                aria-controls="chart"
                aria-selected="true"
                @click="currentTab = 2"
            >
              Chart
            </a>
          </li>
        </ul>
      </div>

      <div class="my-4">
        <div class="tab-content" id="pills-tabContent">
          <div
              class="tab-pane fade"
              :class="{ 'show active': currentTab === 1 }"
              id="feed_news"
              role="tabpanel"
              aria-labelledby="feed_news-tab"
              v-if="currentTab === 1"
          >
            <div style="position: relative; margin-top: 16px">
              <div
                  class="text-center"
                  v-if="initialDataLoaded && activityFeedIsEmpty"
              >
                Activity feed is empty for now.
              </div>

              <div v-if="pinnedFeed">
                <activity-feed-post
                    :key="pinnedFeed.id"
                    :activityFeed="pinnedFeed"
                    :userGroups="userGroups"
                    :company="company"
                    :pinned="true"
                    v-on:refreshFeed="refreshFeed"
                    @editFeed="editFeed"
                />
              </div>
              <div v-for="activityFeed in activityFeeds" :key="activityFeed.id">
                <activity-feed-post
                    :key="activityFeed.id"
                    :activityFeed="activityFeed"
                    :userGroups="userGroups"
                    :company="company"
                    :pinned="activityFeed.pinned_from_company"
                    v-if="activityFeed.type === 'activity_feed'"
                    v-on:refreshFeed="refreshFeed"
                    @editFeed="editFeed"
                />
                <div v-else class="d-flex justify-content-between flex-column">
                  <div>
                    <svg height="14" width="14">
                      <circle
                          cx="7"
                          cy="7"
                          r="5"
                          :fill="availabilityColor(activityFeed.content)"
                      />
                    </svg>
                    <span
                        v-tooltip.auto="
                        generateTooltipText(activityFeed.additionalUsers)
                      "
                    >
                      {{ activityFeed.firstUser }}
                      <span v-if="activityFeed.additionalUsers.length > 0">
                        {{
                          generateAdditionalText(activityFeed.additionalUsers)
                        }}
                      </span>
                      {{ activityFeed.status_text }}
                    </span>
                  </div>
                  <div class="time">
                    {{
                      timeFormatter.displayFullDateTime(
                          new Date(activityFeed.created_at),
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center" v-if="this.currentPage < this.lastPage">
              <button
                  class="btn btn-link font-weight-bold p-0"
                  @click="loadMoreFeeds()"
              >
                Show more
              </button>
            </div>

            <div
                class="modal fade"
                id="activityFeedModal"
                tabindex="-1"
                role="dialog"
                aria-hidden="true"
            >
              <div class="modal-dialog">
                <div class="modal-content" style="border-radius: 0">
                  <div class="modal-body">
                    <div
                        class="position-absolute"
                        style="top: -17px; right: -17px"
                    >
                      <button
                          class="btn"
                          data-dismiss="modal"
                          ref="dismiss"
                          @click="resetFields"
                          style="
                          background: #000;
                          color: #fff;
                          width: 40px;
                          height: 40px;
                          border-radius: 50%;
                          line-height: 1;
                        "
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                    <div class="wfh-modal-title">
                      {{ activityFeedModelTitle }}
                    </div>
                    <div class="wfh-form-label">Message</div>
                    <div
                        v-if="activityFeedImage"
                        class="d-flex justify-content-center mb-2"
                        style="max-height: 120px"
                    >
                      <div class="wfh-modal-image-container">
                        <img
                            v-bind:src="activityFeedImagePreview"
                            alt="Image preview"
                        />
                        <button title="Remove Image" @click="removeFeedImage()">
                          <i class="fas fa-times"></i>
                        </button>
                      </div>
                    </div>

                    <MetaSection
                        v-if="newActivityFeed.showMeta && newActivityFeed.meta"
                        :description="newActivityFeed.meta.description"
                        :image="newActivityFeed.meta.image"
                        :title="newActivityFeed.meta.title"
                        :url="newActivityFeed.meta.url"
                        @onRemoveMeta="removeMeta"
                    />

                    <ckeditor-wfh v-model="newActivityFeed.content"></ckeditor-wfh>
                    <div class="toolbox">
                      <div>
                        <button class="tools" @click="toggleImageUpload">
                          <i class="fas fa-camera"></i>
                        </button>
                      </div>
                      <div>
                        <button
                            class="
                            btn btn-default
                            wfh-btn-filled
                            position-relative
                          "
                            :disabled="disabledSubmit"
                            @click="submitPost"
                        >
                          <span
                              class="spinner-border position-absolute"
                              role="status"
                              style="
                              left: 8px;
                              top: 8px;
                              height: 12px;
                              width: 12px;
                            "
                              v-if="submittingPost"
                          >
                            <span class="sr-only">Loading...</span>
                          </span>
                          {{ isEditFeed ? 'Save' : 'Post' }}
                        </button>
                      </div>
                    </div>

                    <div class="d-flex align-items-center py-2">
                      <div class="mr-2">
                        <user-avatar
                            :avatarURL="currentUser.avatar_src"
                        ></user-avatar>
                      </div>
                      <div v-if="showAdmin && !isEditFeed">
                        <label
                            class="
                            font-weight-light
                            d-flex
                            align-items-center
                            m-0
                          "
                            style="cursor: pointer"
                        >
                          <button
                              class="
                              task-checkbox
                              btn
                              p-0
                              m-2
                              border-0
                              d-flex
                              align-self-center
                              shadow-none
                            "
                              style="
                              opacity: 100%;
                              padding: 0 !important;
                              background-color: #f2f2f2;
                              width: 24px;
                              height: 24px;
                            "
                              @click="toggleNewPostPin"
                          >
                            <img
                                :src="'/images/Icon-1.svg'"
                                v-if="newActivityFeed.pinned"
                                style="width: 23px"
                            />
                          </button>
                          Pin this message</label
                        >
                      </div>
                      <div v-if="!isEditFeed" style="margin: 0 0 0 auto">
                        <select
                            class="form-control"
                            v-model="newActivityFeed.visibility"
                        >
                          <option value="public">Public</option>
                          <option
                            v-for="userGroup of userGroups"
                            :value="'team_' + userGroup.id"
                            :key="userGroup.id"
                            >
                            {{ userGroup.name }} team only
                          </option>
                          <option value="company">My company only</option>
                          <option value="private">Only me</option>
                        </select>
                      </div>
                    </div>

                    <input
                        type="file"
                        ref="fileUpload"
                        hidden
                        accept="image/*"
                        @change="uploadImage($event)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
              class="tab-pane fade"
              :class="{ 'show active': currentTab === 2 }"
              id="chart"
              role="tabpanel"
              aria-labelledby="chart-tab"
              v-if="currentTab === 2"
          >
            <productivity-chart
                v-if="company && userGroups"
                :company="company"
                :userGroups="userGroups"
                :currentUser="currentUser"
            ></productivity-chart>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Timeformatter from './Timeformatter';
import 'v-tooltip';
import ImageCompressor from '../../ImageCompressor';
import { getMetadata } from 'page-metadata-parser';
import _ from 'lodash';
import MetaSection from '../Misc/MetaSection';

export default {
  components: { MetaSection },

  data () {
    return {
      timeFormatter: Timeformatter,
      activityFeeds: [],
      pinnedFeed: null,
      newActivityFeed: {
        id: '',
        content: '',
        image: '',
        imagePreview: '',
        visibility: 'company',
        pinned: false,
        showMeta: true,
        meta: null,
        existingImage: '',
        existingImagePreview: '',
        removeImage: false,
      },
      company: null,
      currentPage: 1,
      lastPage: 1,
      perPage: 15,
      submittingPost: false,
      userGroups: null,
      currentTab: 1,
      cachedUrlMeta: new Map(),
      initialDataLoaded: false,
      isEditFeed: false,
    };
  },

  computed: {
    currentUser () {
      return this.$store.state.currentUser;
    },

    disabledSubmit () {
      return (
          this.submittingPost ||
          (this.newActivityFeed.content === '' &&
              this.newActivityFeed.image === '')
      );
    },

    showAdmin () {
      return this.$store.state.isAdmin;
    },

    activityFeedIsEmpty () {
      return this.activityFeeds.length === 0 && !this.pinnedFeed;
    },

    activityFeedModelTitle () {
      return this.isEditFeed ? 'Update feed' : 'Post on activity feed';
    },

    activityFeedImage () {
      return this.isEditFeed && this.newActivityFeed.image === ''
          ? this.newActivityFeed.existingImage
          : this.newActivityFeed.image;
    },

    activityFeedImagePreview () {
      return this.isEditFeed && this.newActivityFeed.imagePreview === ''
          ? this.newActivityFeed.existingImagePreview
          : this.newActivityFeed.imagePreview;
    },

    tasksEnabled () {
      return hasPermission('tasks');
    }
  },

  watch: {
    currentUser () {
      if (!this.currentUser.id) return;

      this.getUserData();
    },

    'newActivityFeed.content' () {
      this.newActivityFeed.showMeta = true;

      if (this.newActivityFeed.content === '') {
        this.resetFields();
      } else {
        if (this.newActivityFeed.meta !== null) {
          return;
        }

        this.getPostMeta(this.newActivityFeed.content);
      }
    },

    currentTab () {
      localStorage.activityFeed_currentTab = this.currentTab;
    },
  },

  methods: {
    getPostMeta: _.debounce(async function (post) {
      const urlRegex =
          /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;
      const urls = post.match(urlRegex);

      if (urls !== null) {
        const url = urls[0].replace(/<\/?[^>]+(>|$)/g, ''); // To remove any potential html element remains in the string
        const encodedUrl = encodeURI(url);
        const cachedMeta = this.cachedUrlMeta.get(encodedUrl);
        this.hasMetaUrlError = false;

        if (cachedMeta) {
          this.newActivityFeed.meta = cachedMeta;
        } else {
          try {
            const htmlContent = await axios.get(
                `get-url-content?url=${encodedUrl}`,
            );
            const htmlHead = htmlContent.data.match(
                /<head[^>]*>[\s\S]*<\/head>/gi,
            );

            var el = document.createElement('html');
            el.innerHTML = htmlHead[0];
            const meta = getMetadata(el, encodedUrl);
            const parsedMeta = {
              url: meta.url,
              title: meta.title ? meta.title.substr(0, 100) : '',
              description: meta.description
                  ? meta.description.substr(0, 100)
                  : '',
              image: meta.image,
              icon: meta.icon,
            };

            this.cachedUrlMeta.set(encodedUrl, parsedMeta);
            this.newActivityFeed.meta = parsedMeta;
          } catch (e) {
            this.hasMetaUrlError = true;
          }
        }
      }
    }, 600),

    generateTooltipText (users) {
      return users.join(', ');
    },

    generateAdditionalText (users) {
      return `and ${users.length} others`;
    },

    async submitPost () {
      try {
        this.submittingPost = true;
        let formData = new FormData();

        if (this.newActivityFeed.image) {
          const file = this.newActivityFeed.image;
          const imageSrc = file;
          const imageName = file.name;
          const fileType = file.type.split('/')[1];
          const imageBlob = window.URL.createObjectURL(imageSrc);
          const compressedImage = await ImageCompressor(
              imageBlob,
              imageName,
              fileType,
          );
          formData.append('image', compressedImage);
        }

        if (this.isEditFeed && this.newActivityFeed.removeImage === true) {
          formData.append('removeImage', true);
        }

        Object.keys(this.newActivityFeed).forEach((key) => {
          if (
              ![
                'image',
                'existingImage',
                'existingImagePreview',
                'removeImage',
              ].includes(key)
          ) {
            const value =
                key === 'meta'
                    ? JSON.stringify(this.newActivityFeed[key])
                    : this.newActivityFeed[key];

            if (typeof value === 'boolean') {
              formData.append(key, value === true ? '1' : '0');
            } else {
              formData.append(key, value);
            }
          }
        });

        if (!this.newActivityFeed.showMeta || !this.newActivityFeed.meta) {
          formData.delete('meta');
        }

        if (this.isEditFeed) {
          await axios.post(
              `activity-feeds/${this.newActivityFeed.id}`,
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              },
          );
        } else {
          await axios.post('activity-feeds', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
        }

        this.resetFields();
        this.$refs.dismiss.click();
        this.refreshFeed();
      } finally {
        if (!this.newActivityFeed.pinned) {
          window.scrollTo({
            top: 200,
            behavior: 'smooth',
          });
        }
      }
    },

    async getActivityFeedPosts () {
      const total = this.currentPage * this.perPage;
      const { data } = await axios.get(`activity-feeds?per_page=${total}`);

      let result = data.data;
      this.activityFeeds = result.data;
      this.currentPage = result.current_page;
      this.lastPage = result.last_page;
      this.perPage = result.per_page;
    },

    async getPinnedFeed () {
      this.pinnedFeed = null;
      const res = await axios.get(`activity-feeds?pinned=true`);

      if (res.data || res.data.data.length > 0) {
        this.pinnedFeed = res.data.data;
      }
    },

    async getUserData () {
      if (!this.currentUser.id) {
        return;
      }

      const groups = await axios.get(`users/${this.currentUser.id}/groups`);

      this.userGroups = groups.data.data;
    },

    uploadImage (event) {
      this.newActivityFeed.image = event.target.files[0];
      this.newActivityFeed.imagePreview = window.URL.createObjectURL(
          this.newActivityFeed.image,
      );
    },

    toggleImageUpload () {
      this.$refs.fileUpload.click();
    },

    toggleNewPostPin () {
      this.newActivityFeed.pinned = !this.newActivityFeed.pinned;
    },

    resetFields () {
      this.isEditFeed = false;
      this.newActivityFeed.content = '';
      this.newActivityFeed.image = '';
      this.newActivityFeed.imagePreview = '';
      this.newActivityFeed.visibility = 'company';
      this.newActivityFeed.pinned = false;
      this.submittingPost = false;
      this.newActivityFeed.showMeta = true;
      this.newActivityFeed.meta = null;
      this.newActivityFeed.existingImage = '';
      this.newActivityFeed.existingImagePreview = '';
      this.newActivityFeed.removeImage = false;
    },

    async generateListeners () {
      const res = await axios.get('following-companies');
      res.data.data.forEach((id) => {
        window.Echo.private(`activity-feeds-updated.${id}`).listen(
            '.activity-feed-updated',
            (e) => {
              this.refreshFeed();
            },
        );
      });
    },

    async getCurrentCompany () {
      const res = await axios.get('get-user-company');
      this.company = res.data.data;
      window.Echo.private(`company.${res.data.data.id}`).listen(
          '.user-availability-updated',
          (e) => {
            this.refreshFeed();
          },
      );
    },

    availabilityColor (availability) {
      return (
          {
            check_in: '#82df6b',
            continue: '#82df6b',
            check_out: '#e0e0e0',
            break: '#e0e0e0',
            away: '#ffe171',
          }[availability] || '#e0e0e0'
      );
    },

    async loadMoreFeeds () {
      if (this.currentPage < this.lastPage) {
        this.currentPage += 1;
        const res = await axios.get(`activity-feeds?page=${this.currentPage}`);

        this.activityFeeds = [...this.activityFeeds, ...res.data.data.data];
      }
    },

    removeMeta () {
      this.newActivityFeed.showMeta = false;
      this.newActivityFeed.meta = null;
    },

    refreshFeed () {
      this.getPinnedFeed();
      this.getActivityFeedPosts();
    },

    editFeed ({ id, content, image }) {
      let activityFeedModal = $('#activityFeedModal').modal({
        keyboard: false,
      });

      this.isEditFeed = true;
      this.newActivityFeed.id = id;
      this.newActivityFeed.content = content;
      this.newActivityFeed.existingImage = image ?? '';
      this.newActivityFeed.existingImagePreview = image ?? '';

      activityFeedModal.modal('show');
    },

    removeFeedImage () {
      this.newActivityFeed.existingImage = '';
      this.newActivityFeed.existingImagePreview = '';
      this.newActivityFeed.image = '';
      this.newActivityFeed.imagePreview = '';
      this.newActivityFeed.removeImage = true;
    },
  },

  async mounted () {
    if (localStorage.activityFeed_currentTab) {
      this.currentTab = parseInt(localStorage.activityFeed_currentTab);
    }

    // if task disabled, show news on landing
    if(!this.tasksEnabled){
      this.currentTab = 1;
    }

    this.getCurrentCompany();
    this.generateListeners();
    this.getUserData();

    await this.getPinnedFeed();
    await this.getActivityFeedPosts();

    this.initialDataLoaded = true;
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.wfh-modal-title {
  color: #222227;
  font-family: "Lato", sans-serif;
  font-size: 28px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 60px;
  text-align: center;
}

.btn-link {
  padding: 0 !important;
  color: #0db4e6;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
}

.post-input {
  border-radius: 0;
  background-color: #fff;
  resize: none;
  position: relative;
  border-top: 1px solid #dce2ed;
  border-right: 1px solid #dce2ed;
  border-left: 1px solid #dce2ed;
  border-bottom: none;
}

.post-input:active,
.post-input:focus {
  background-color: #fff;
}

.wfh-btn-filled {
  padding: 2px 0 !important;
  min-width: 80px;
  border-radius: 6px;
  background-color: #000;
  color: #fff;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 22px;
  text-align: center;
}

.toolbox {
  padding: 8px;
  border-radius: 0;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: none;
  border-bottom: 1px solid #dce2ed;
  border-right: 1px solid #dce2ed;
  border-left: 1px solid #dce2ed;
}

.tools,
.tool:hover,
.tool:active {
  background: none;
  border: none !important;
  color: #9696a8;
  outline: 0;
}

@media (max-width: 768px) {
  .modal-dialog {
    right: 0 !important;
    left: 0 !important;
    bottom: 0 !important;
    position: absolute !important;
    margin: 0 !important;
  }
}

.time {
  color: #808fa4;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 22px;
}

.nav-border-override .active {
  border: none;
  background-color: #fff !important;
  border-bottom: #ff375e 4px solid;
}

.nav-pills .nav-link,
.nav-pills .nav-link:hover {
  color: #313131 !important;
  font-family: "Lato", sans-serif;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  text-align: center;
}

.nav-pills .nav-link.active {
  background-color: #fff !important;
  border-radius: 0 !important;
  font-weight: bold;
  color: #313131 !important;
}

.wfh-modal-image-container {
  position: relative;

  img {
    border-radius: 4px;
    max-height: 120px;
    max-width: 100%;
    width: 100%;
    height: auto;
  }

  button {
    border: none;
    position: absolute;
    top: -10px;
    right: -10px;
    background-color: #ff375e;
    color: white;
    border-radius: 50%;
    font-size: 10px;
    padding: 0.2rem 0.5rem;
  }
}
</style>
